<!-- components/JaEnBlock.vue -->
<template>
  <div class="ja-en-block">
    <p lang="ja" class="ja" v-html="ja"></p>
    <p lang="en" class="en" v-html="en"></p>
  </div>
</template>

<style scoped lang="scss">
.ja{
  font-size: 1.04rem;
}
.en {
  font-size: .92rem;
  opacity: 0.64;
  margin: 1.2rem 0 0;
}
</style>

<script>
export default {
  props: {
    ja: {
      type: String,
      required: false
    },
    en: {
      type: String,
      required: false
    },
  }
}
</script>